<template>
  <common-alert type="primary"
                :title="$t('oauth2_implements.AutoSignin.loginSuccess')"
                :title-img="success"
                :btn-text="$t('oauth2_implements.AutoSignin.toHomePage')"
                :on-click="gotoHome">
    <p>{{ $t('oauth2_implements.AutoSignin.loginSuccessMsg') }}<span>{{ countDown }}</span></p>
  </common-alert>
</template>

<script lang="ts" setup>
import { CORE_USER, type UserService } from '@/core'
import Cookie from 'js-cookie'
import { container } from 'tsyringe'
import { onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useOauth2 } from '../Oauth2Plugin'
import success from './assets/imgs/success.png'
import CommonAlert from './CommonAlert.vue'

const oauth2State = useOauth2()
const { wechat } = oauth2State.$state
const router = useRouter()
const gotoHome = () => {
  router.push('/')
}

const b64DecodeUnicode = (str: string) => {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

const userInfo = Cookie.get(wechat.userInfoCookieKey)
if (userInfo) {
  const userService = container.resolve<UserService>(CORE_USER)
  const user = JSON.parse(b64DecodeUnicode(userInfo))
  userService.setUser({
    user
  })
} else {
  router.push('/signin')
}

const countDown = ref<number>(5)
const counter = setInterval(function () {
  countDown.value = countDown.value - 1
  if (countDown.value == 0) {
    clearInterval(counter)
    router.push('/')
  }
}, 1000)

onUnmounted(() => {
  clearInterval(counter)
})
</script>
